<template>
  <carousel
    ref="carousel"
    v-if="images.length > 1"
    class="relative h-full"
    :number-of-slides="images.length"
    :per-page-custom="[
      [320, 1],
      [848, 1],
    ]"
  >
    <template v-slot:default="{ carousel }">
      <v-slide v-for="(item, imageIndex) in images" :key="imageIndex">
        <div
          class="cover-image rounded-tl rounded-tr w-full h-full"
          v-if="
            imageIndex >= carousel.currentPage - 1 &&
              imageIndex <= carousel.currentPage + 1
          "
        >
          <img
            :src="getCloudinaryImage(item)"
            class="w-full h-full cover-image rounded-tl"
          />
        </div>
      </v-slide>
    </template>

    <template v-slot:navigation="{ carousel }">
      <div>
        <div class="resort-room-arrow-nav px-4">
          <button
            type="button"
            class="resort-room-nav-btn"
            @click="carousel.goToPrevPage"
            :disabled="!carousel.canAdvanceBackward"
          >
            <svg width="24" height="24" class="mx-auto">
              <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
            </svg>
          </button>
          <div class="flex-1 h-0"></div>
          <button
            type="button"
            class="resort-room-nav-btn"
            @click="carousel.goToNextPage"
            :disabled="!carousel.canAdvanceForward"
          >
            <svg width="24" height="24" class="mx-auto">
              <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
            </svg>
          </button>
        </div>

        <div class="resort-room-dotted-nav rounded-bl">
          <div
            v-for="(image, imageIndex) in images"
            :key="imageIndex"
            class="carousel-bullet"
            :class="{
              'carousel-bullet--active': carousel.currentPage === imageIndex,
            }"
            @click="carousel.goToPage(imageIndex)"
          ></div>
        </div>
      </div>
    </template>
  </carousel>
  <div v-else class="w-full h-full">
    <img
      :src="getCloudinaryImage(images[0])"
      class="w-full h-full cover-image rounded-tl sm:rounded"
    />
  </div>
</template>

<script>
import { Slide } from "vue-carousel";

import Carousel from "../../components/core/Carousel";
import { getCloudinaryUrl } from "../../helpers";

export default {
  props: ["images", "width"],
  components: {
    "v-slide": Slide,
    Carousel,
  },
  methods: {
    getCloudinaryImage(url) {
      return getCloudinaryUrl(url, { width: this.width || 600 });
    },
  },
};
</script>
